import React, { useState, useEffect } from 'react';
import '../pages/KullaniciYonetimi.css';

const KullaniciYonetimi = () => {
  const [kullanicilar, setKullanicilar] = useState([]);
  const [loading, setLoading] = useState(true);
  const [yeniKullanici, setYeniKullanici] = useState({ 
    ad: '', 
    email: '', 
    password: '', 
    rol: 'teknisyen' 
  });

  // ✅ Backend'den kullanıcıları yükle
  useEffect(() => {
    fetchKullanicilar();
  }, []);

  const fetchKullanicilar = async () => {
    try {
      setLoading(true);
      const response = await fetch('/api/kullanicilar');
      const data = await response.json();
      setKullanicilar(data);
    } catch (error) {
      console.error('Kullanıcıları yükleme hatası:', error);
      alert('❌ Kullanıcılar yüklenemedi');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setYeniKullanici((prev) => ({ ...prev, [name]: value }));
  };

  // ✅ Backend'e yeni kullanıcı ekle
  const handleEkle = async () => {
    if (!yeniKullanici.ad || !yeniKullanici.email || !yeniKullanici.password) {
      return alert('❌ Lütfen tüm alanları doldurunuz');
    }

    try {
      const response = await fetch('/api/kullanicilar', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(yeniKullanici)
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.hata || 'Kullanıcı eklenemedi');
      }

      alert(`✅ Kullanıcı başarıyla eklendi!\n\nEmail: ${data.email}\nŞifre: ${yeniKullanici.password}`);
      
      // Formu temizle
      setYeniKullanici({ ad: '', email: '', password: '', rol: 'teknisyen' });
      
      // Listeyi yenile
      fetchKullanicilar();
    } catch (error) {
      console.error('Kullanıcı ekleme hatası:', error);
      alert('❌ ' + error.message);
    }
  };

  // ✅ Backend'den kullanıcı sil
  const handleSil = async (kullanici) => {
    // Admin kullanıcıyı silme
    if (kullanici.email === 'admin@moonx24.com') {
      return alert('❌ Admin kullanıcı silinemez!');
    }

    const onay = window.confirm(
      `${kullanici.ad} kullanıcısını silmek istediğinizden emin misiniz?`
    );
    if (!onay) return;

    try {
      const response = await fetch(`/api/kullanicilar/${kullanici.id}`, {
        method: 'DELETE'
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.hata || 'Kullanıcı silinemedi');
      }

      alert('✅ Kullanıcı silindi');
      fetchKullanicilar();
    } catch (error) {
      console.error('Kullanıcı silme hatası:', error);
      alert('❌ ' + error.message);
    }
  };

  // ✅ Backend'de kullanıcı güncelle
  const handleRolGuncelle = async (kullanici, yeniRol) => {
    try {
      const response = await fetch(`/api/kullanicilar/${kullanici.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ rol: yeniRol })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.hata || 'Rol güncellenemedi');
      }

      fetchKullanicilar();
    } catch (error) {
      console.error('Rol güncelleme hatası:', error);
      alert('❌ ' + error.message);
    }
  };

  // ✅ Şifre sıfırlama
  const handleSifreSifirla = async (kullanici) => {
    const yeniSifre = window.prompt(
      `${kullanici.ad} için yeni şifre girin:`,
      '123456'
    );

    if (!yeniSifre) return;

    try {
      const response = await fetch(`/api/kullanicilar/${kullanici.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password: yeniSifre })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.hata || 'Şifre sıfırlanamadı');
      }

      alert(`✅ Şifre sıfırlandı!\n\nYeni şifre: ${yeniSifre}`);
    } catch (error) {
      console.error('Şifre sıfırlama hatası:', error);
      alert('❌ ' + error.message);
    }
  };

  if (loading) {
    return (
      <div className="kullanici-yonetimi-container">
        <h2>👥 Kullanıcı Yönetimi</h2>
        <p>Yükleniyor...</p>
      </div>
    );
  }

  return (
    <div className="kullanici-yonetimi-container">
      <h2>👥 Kullanıcı Yönetimi</h2>
      
      {/* ✅ YENİ KULLANICI FORMU */}
      <div className="form">
        <h3>➕ Yeni Kullanıcı Ekle</h3>
        <input
          type="text"
          name="ad"
          placeholder="Ad Soyad"
          value={yeniKullanici.ad}
          onChange={handleChange}
        />
        <input
          type="email"
          name="email"
          placeholder="E-posta"
          value={yeniKullanici.email}
          onChange={handleChange}
        />
        <input
          type="password"
          name="password"
          placeholder="Şifre"
          value={yeniKullanici.password}
          onChange={handleChange}
        />
        <select name="rol" value={yeniKullanici.rol} onChange={handleChange}>
          <option value="admin">Admin</option>
          <option value="teknisyen">Teknisyen</option>
          <option value="satış">Satış</option>
          <option value="muhasebe">Muhasebe</option>
        </select>
        <button onClick={handleEkle}>Ekle</button>
      </div>

      {/* ✅ KULLANICI LİSTESİ */}
      <div className="kullanici-listesi">
        <h3>📋 Kayıtlı Kullanıcılar ({kullanicilar.length})</h3>
        {kullanicilar.map((k) => (
          <div key={k.id} className="kullanici-kart">
            <div className="kullanici-info">
              <p><strong>{k.ad}</strong></p>
              <p className="email">{k.email}</p>
              {k.email === 'admin@moonx24.com' && (
                <span className="admin-badge">👑 Admin</span>
              )}
            </div>
            
            <div className="kullanici-actions">
              <div className="rol-section">
                <label>Rol:</label>
                <select 
                  value={k.rol} 
                  onChange={(e) => handleRolGuncelle(k, e.target.value)}
                  disabled={k.email === 'admin@moonx24.com'}
                >
                  <option value="admin">Admin</option>
                  <option value="teknisyen">Teknisyen</option>
                  <option value="satış">Satış</option>
                  <option value="muhasebe">Muhasebe</option>
                </select>
              </div>

              <div className="button-group">
                <button 
                  className="btn-sifre"
                  onClick={() => handleSifreSifirla(k)}
                >
                  🔑 Şifre Sıfırla
                </button>
                <button 
                  className="btn-sil"
                  onClick={() => handleSil(k)}
                  disabled={k.email === 'admin@moonx24.com'}
                >
                  🗑️ Sil
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default KullaniciYonetimi;